import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import { notificationsReducer,statusReducer } from "./app/base/reducers";
import { auditLogEntitiesReducer,auditLogsReducer } from "./app/logs/reducers";
import { LOGOUT_SUCCESS } from "./app/nav/constants";
import { userReducer } from "./app/nav/reducers";
import {
  changesetsReducer,
  groupsReducer,
  permissionsReducer,
  policiesReducer,
  productsReducer,
  resourcesReducer,
  resourceTypesReducer,
  rolesReducer,
  servicesReducer,
  usersReducer} from "./app/policies/reducers/index";
import modalReducer from "./app/shared/reducers";

const createAppReducer = history =>
  combineReducers({
    changesets: changesetsReducer,
    notifications: notificationsReducer,
    status: statusReducer,
    products: productsReducer,
    services: servicesReducer,
    resources: resourcesReducer,
    resourceTypes: resourceTypesReducer,
    user: userReducer,
    users: usersReducer,
    groups: groupsReducer,
    roles: rolesReducer,
    policies: policiesReducer,
    permissions: permissionsReducer,
    auditLogs: auditLogsReducer,
    auditLogEntities: auditLogEntitiesReducer,
    modal: modalReducer,
    router: connectRouter(history)
  });

const createRootReducer = history => (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    return createAppReducer(history)(undefined, action);
  }
  return createAppReducer(history)(state, action);
};

export default createRootReducer;
